<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "LabelHint" });
import "tailwindcss/tailwind.css";
import { t } from "svelte-i18n";
export let hint = void 0;
export let id = void 0;
export let isDisabled = false;
</script>

{#if hint !== null}
    <label
        for = { id }
        class:s8-disabled = { isDisabled }
    >
        {#if hint !== undefined}
            <!-- eslint-disable-next-line svelte/no-at-html-tags -->
            { @html $t(hint) }
        {/if}
    </label>
{/if}

<style>

    label {
        display: block;

        color: rgba(39,39,17,0.36);
        font-size: 9px;
        line-height: 10px;
        text-align: right;
        opacity: 0;
        transition: opacity 0.5s ease-in-out;
    }

        label:not(:empty) {
            opacity: 1;
        }

        label.s8-disabled {
            color: rgba(39,39,17,0.24);
        }</style>